import { render } from "./indexelevenservices.vue?vue&type=template&id=3b89c4e9"
import script from "./indexelevenservices.vue?vue&type=script&lang=js"
export * from "./indexelevenservices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__